import { timelineItems } from "@/mocks/home";

const toneMap: Record<string, string> = {
  hot: "bg-primary-100 text-primary-700 border-primary-200",
  live: "bg-accent-100 text-accent-900 border-accent-300",
  debate: "bg-secondary-100 text-secondary-900 border-secondary-200",
  deep: "bg-background-200 text-foreground-700 border-background-300",
};

export default function NewsTimeline() {
  return (
    <ol className="relative border-l border-background-300 pl-5 md:pl-7">
      {timelineItems.map((item) => (
        <li key={item.time} className="relative pb-6 last:pb-0">
          <span className="absolute -left-[26px] top-1.5 flex h-3 w-3 items-center justify-center md:-left-[34px]">
            <span className="h-2.5 w-2.5 rounded-full border-2 border-primary-500 bg-background-50" />
          </span>

          <div className="rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 md:p-5">
            <div className="flex flex-wrap items-center gap-2">
              <span className="font-label text-xs text-foreground-500">{item.time}</span>
              <span
                className={`rounded-full border px-2.5 py-0.5 text-[11px] font-medium ${
                  toneMap[item.tone] ?? toneMap.deep
                }`}
              >
                {item.tag}
              </span>
            </div>

            <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
              {item.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>

            <div className="mt-3 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
              <span className="flex items-center gap-1.5">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-chat-3-line text-sm" />
                </span>
                {item.comments.toLocaleString()} 条讨论
              </span>
              <span className="flex items-center gap-1.5">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-fire-line text-sm" />
                </span>
                热度 {item.heat}
              </span>
              <a
                href="#voices"
                className="ml-auto flex items-center gap-1 whitespace-nowrap text-primary-600 transition-colors hover:text-primary-700"
              >
                看网友怎么说
                <i className="ri-arrow-right-s-line" />
              </a>
            </div>
          </div>
        </li>
      ))}
    </ol>
  );
}